"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteLocation = exports.getLocations = exports.createLocation = exports.updateLocation = exports.getLocation = exports.setUserSettings = exports.isTablet = exports.getUserFromLocalStorage = exports.getEPSGCodes = exports.deleteFile = exports.insertFile = exports.getFiles = exports.getFile = exports.getProjectGroups = void 0;
let user = null;
function getProjectGroups(projectId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        const endpointStr = '/getProjectGroups?project_id=' + projectId;
        yield keycloakfetch.get(settings.apiUrl + endpointStr).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.getProjectGroups = getProjectGroups;
/* *********************************************************************************************************************
 * Files
 **********************************************************************************************************************/
function getFile(projectId, fileId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = {};
        if (fileId === null)
            return { data: null };
        yield keycloakfetch.get(settings.apiUrl + '/getFile?project_id=' + projectId + '&file_id=' + fileId).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.getFile = getFile;
function getFiles(projectId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = {};
        yield keycloakfetch.get(settings.apiUrl + '/getFiles?project_id=' + projectId).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.getFiles = getFiles;
function insertFile(data, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.put(settings.apiUrl + '/insertFile', data).then((result) => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.insertFile = insertFile;
function deleteFile(projectId, fileId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        const data = {
            'project_id': projectId,
            'file_id': fileId
        };
        yield keycloakfetch.delete(settings.apiUrl + '/deleteFile', data).then((result) => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.deleteFile = deleteFile;
function getEPSGCodes(projectId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.get(settings.apiUrl + '/getEPSGCodes?project_id=' + projectId).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.getEPSGCodes = getEPSGCodes;
function getUserFromLocalStorage() {
    if (user === null) {
        console.log('getUserFromLocalStorage');
        user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            user = {};
        }
        if (user.settings === null) {
            user.settings = {};
        }
    }
    // console.log('user', user);
    return user;
}
exports.getUserFromLocalStorage = getUserFromLocalStorage;
const isTablet = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    return isTablet;
};
exports.isTablet = isTablet;
function setUserSettings(key, value, keycloakfetch, settings, projectId, withoutApiCall) {
    return __awaiter(this, void 0, void 0, function* () {
        let tmp_user = getUserFromLocalStorage();
        if (typeof user.settings === 'undefined')
            return;
        if (projectId) {
            if (!tmp_user.settings[projectId]) {
                tmp_user.settings[projectId] = {};
            }
            tmp_user.settings[projectId][key] = value;
        }
        else {
            tmp_user.settings[key] = value;
        }
        if (!withoutApiCall) {
            yield keycloakfetch.put(settings.apiUrl + '/updateUserSettings', tmp_user.settings).then((result) => {
                if (result) {
                    localStorage.setItem('user', JSON.stringify(tmp_user));
                    user = JSON.parse(localStorage.getItem('user'));
                }
            });
        }
    });
}
exports.setUserSettings = setUserSettings;
function getLocation(projectId, locationId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = {};
        yield keycloakfetch.get(settings.apiUrl + '/getLocation?project_id=' + projectId + '&location_id=' + locationId).then(result => {
            if (result)
                retValue = result[0];
        });
        return retValue;
    });
}
exports.getLocation = getLocation;
function updateLocation(data, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.post(settings.apiUrl + '/updateLocation', data).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.updateLocation = updateLocation;
function createLocation(data, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.put(settings.apiUrl + '/createLocation', data).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.createLocation = createLocation;
function getLocations(projectId, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.get(settings.apiUrl + '/getLocations?project_id=' + projectId).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.getLocations = getLocations;
function deleteLocation(projectId, locationIds, keycloakfetch, settings) {
    return __awaiter(this, void 0, void 0, function* () {
        let retValue = [];
        yield keycloakfetch.delete(settings.apiUrl + '/deleteLocation', {
            'project_id': projectId,
            'location_ids': locationIds
        }).then(result => {
            if (result)
                retValue = result;
        });
        return retValue;
    });
}
exports.deleteLocation = deleteLocation;
